import React from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import {
  setCallEnd,
  setCallNumber,
  setScreenType,
  useCallId,
  useCallNumber,
  useCallType
} from '../../../store/slices/dialSlice';
import PropTypes from 'prop-types';
import { dtmfPress } from '../../../store/slices/callingSlice';
import { convertToMask } from '../../../utils/common';
import { useUserDetails } from '../../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';

const TransferHangupScreen = ({ number }) => {
  const user = useUserDetails();
  const callNumber = useCallNumber();
  const callId = useCallId();
  const callType = useCallType();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onDtmfPress = async (val) => {
    try {
      const payload = {
        uuid: callId,
        dtmf_number: val,
        calltype: callType
      };
      const response = await dispatch(dtmfPress(payload)).unwrap();
      if (response && (val === '0' || val === '#')) {
        dispatch(setScreenType('LIVE_CALL'));
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-auto text-white text-center fw-bold fs-4">
        {user?.process_details?.numberMasking === 'true'
          ? convertToMask(callNumber || number)
          : callNumber || number}
      </div>

      <div className="text-center text-white transfer-call-button-grid hangup-call-button-grid mb-auto">
        <div className="d-flex flex-column align-items-center">
          <Button color="dark" className="mb-1" onClick={() => onDtmfPress('0')}>
            <i className="bi bi-telephone-plus-fill" />
          </Button>
          <span>{t('threeWayConference')}</span>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Button color="dark" className="mb-1" onClick={() => onDtmfPress('#')}>
            <i className="bi bi-telephone-x-fill" />
          </Button>
          <span>{t('hangupTransferLine')}</span>
        </div>
        <div className="d-flex flex-column align-items-center leave-conference">
          <Button color="dark" className="mb-1" onClick={() => onDtmfPress('*')}>
            <i className="bi bi-telephone-minus-fill" />
          </Button>
          <span>{t('leaveConference')}</span>
        </div>
      </div>
      <div className="call-button-wrapper mt-auto pb-4">
        <Button
          color="danger"
          className="call-end-btn"
          onClick={() => {
            dispatch(setCallEnd(true));
            dispatch(setCallNumber(''));
            dispatch(setScreenType(null));
          }}>
          <i className="bi bi-telephone-x-fill" />
        </Button>
      </div>
    </div>
  );
};

TransferHangupScreen.propTypes = {
  number: PropTypes.string
};

export default TransferHangupScreen;
